import {
  SET_REGISTRATION_DATA,
} from "../types";

export const registrationStates = {
  username: null,
  password: null,
  courses: [],
  programLvl: [],
}

export const registrationReducer = (state, action) => {
  switch (action.type) {
    case SET_REGISTRATION_DATA:
      return {
        ...state,
        ...action.data
      };
    default: return state
  }
};